const radii = {
  none: 0,
  sm: `0.125rem`,
  default: `0.5rem`,
  lg: `1rem`,
  xl: `2rem`,
  xxl: `4rem`,
  full: '4px',
  right: `0 0.5rem 0.5rem 0`,
  left: `0.5rem 0 0 0.5rem`,
  top: `0.5rem 0.5rem 0 0`,
  bottom: `0 0 0.5rem 0.5rem`
}

export default radii